export const ROUTE = {
    PUBLIC_STARTPAGE: {
        PATH: "/",
        NAME: "PublicStartpage"
    },
    PUBLIC_ERROR_PAGE: {
        PATH: "/error",
        NAME: "PublicErrorPage"
    },
    PUBLIC_PAGE_NOT_FOUND: {
        PATH: "/404",
        NAME: "PublicPageNotFound"
    },
    PUBLIC_PAGE_NOT_ALLOWED: {
        PATH: "/403",
        NAME: "PublicPageNotAllowed"
    },
    AUTHENTICATION_CALLBACK: {
        PATH: "/auth/callback",
        NAME: "AuthenticationCallback"
    },
    RESTRICTED_AREA: {
        PATH: "/r",
        NAME: "RestrictedArea"
    },
    SHIPMENT_LIST: {
        PATH: "/r/shipments",
        NAME: "RestrictedShipmentList"
    },
    DASHBOARD: {
        PATH: "/r/dashboard",
        NAME: "RestrictedDashboard"
    }
} as const;
